module.exports = __webpack_public_path__ + "assets/mootools.ba647a0d.svg";